const unallowScroll = () => { //禁止页面滑动
  var mo = function (e) {
    e.preventDefault();
  };
  document.body.style.overflow = "hidden";
  document.addEventListener("touchmove", mo, false);
  // console.log('禁止页面滑动');

}
const allowScroll = () => { //出现滚动条
  // console.log('出现滚动条‘我执行了');
  var mo = function (e) {
    e.preventDefault();
  };
  document.body.style.overflow = "";
  document.removeEventListener("touchmove", mo, false);
}
const undisabled = () => { //禁止页面滑动
  document.body.style.overflow = "hidden";
  document.addEventListener("touchmove", {
    passive: false
  }); // 禁止页面滑动

}
const nodisabled = () => { //出现滚动条
  document.body.style.overflow = ""; // 出现滚动条
  document.removeEventListener("touchmove", {
    passive: false
  });
}
const getCaption = (obj) => {
  var index = obj.lastIndexOf("\!");
  obj = obj.substring(index + 1, obj.length);
  // console.log(obj);
  return obj;
}
export default {
  unallowScroll,
  allowScroll,
  undisabled,
  nodisabled,
  getCaption
}